import { render, staticRenderFns } from "./activity-home.vue?vue&type=template&id=5afe74e8&scoped=true&"
import script from "./activity-home.vue?vue&type=script&lang=js&"
export * from "./activity-home.vue?vue&type=script&lang=js&"
import style0 from "./activity-home.vue?vue&type=style&index=0&id=5afe74e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe74e8",
  null
  
)

export default component.exports